import React from "react";

import { useDictionary } from "hooks";
import { CAYUSE_TYPES } from "globals/constants";

import Integration from "./Integration";


function HumanEthicsStudySearch (props) {
	const dictionary = useDictionary('humanEthicsStudySearch');

	return <Integration title={dictionary.headline ?? 'Human Ethics Study Search'} { ...props }/>;
}

HumanEthicsStudySearch.showInPalette = () => true;

HumanEthicsStudySearch.paletteInformation = () => ({
	id: "cayuseHumanEthicsStudySearch",
	name: "Human Ethics Study Search",
	type: "cayuseHumanEthicsStudySearch",
	group: "sponsoredProject"
});

HumanEthicsStudySearch.newElement = () => ({
	designInfo: {
		stencilSuperIds: [
			"Component"
		],
		stencilId: "cayuse-human-ethics-study-search",
		customStencilId: "null"
	},
	type: CAYUSE_TYPES.HUMAN_ETHICS,
	cayuseShortLabel: "Human Ethics Study Search"
});

HumanEthicsStudySearch.initialValue = "{{humanEthicsStudySearch}}";


export default HumanEthicsStudySearch;
